import React from 'react';
import _ from 'lodash';

class DialogItemIcon extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            expanded: false,
            hovered: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onMouseLeave = () => {
        this.setState({ expanded: false, hovered: false });
    }

    onMouseEnter = () => {
        this.setState({ hovered: true }, () => {
            this.expand();
        });
    }

    expand = _.debounce(() => {
        if (!this._isMounted) return;
        if (this.state.hovered) {
            this.setState({ expanded: true });
        }
    }, 500);

    render() {
        const {
            label,
            children,
            collapsedSize,
            expandedSize,
            reversed,
            onClick
        } = this.props;
        const { expanded } = this.state;
        const height = collapsedSize;
        const width = expanded ? expandedSize : collapsedSize;
        let style = {
            minWidth: `${width}px`,
            width: `${width}px`,
            maxWidth: `${width}px`,
            minHeight: `${height}px`,
            height: `${height}px`,
            maxHeight: `${height}px`,
            borderRadius: `${height}px`,
        };

        let circleStyle = {
            minWidth: `${height}px`,
            width: `${height}px`,
            maxWidth: `${height}px`,
            minHeight: `${height}px`,
            height: `${height}px`,
            maxHeight: `${height}px`,
            borderRadius: `${height}px`,
        };

        return (
            <div
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                onClick={onClick}
                className={`dialog-item-icon ${reversed && 'reversed'}`}
                style={style}>
                <div className="dialog-item-icon__circle" style={circleStyle}>
                    {children}
                </div>
                <div className="dialog-item-icon__label">
                    {label}
                </div>
            </div>
        );
    }
}

export default DialogItemIcon;